export default __webpack_public_path__ + "static/media/post-video-play.9b5de2f7.svg";